<template>
    <student-backend-focus-layout
        content-bg-color="gray-125"
        header-bg-color="gray-125"
        exit-button-text="Exit Worksheet"
        v-on:exit-page-clicked="exitWorksheet"
        :page-title="worksheet.title"
    >
        <template #page_header>
            <div
                class="mx-auto text-center font-semibold text-gray-925 md:hidden"
            >
                {{ worksheet.title }}
            </div>
        </template>
        <template #content>
            <div
                class="mx-auto mb-24 flex h-full w-full max-w-2xl select-none flex-col items-center justify-center gap-4 md:mb-4"
            >
                <div
                    class="w-full"
                    v-for="(module, index) in worksheet.worksheet_modules"
                >
                    <student-worksheet-module-text
                        v-if="module.type === 'text'"
                        v-model="studentResponses[index].response"
                        :module="module"
                        :worksheet-complete="worksheetComplete"
                    ></student-worksheet-module-text>

                    <student-worksheet-module-choice
                        v-if="module.type === 'choice_boolean'"
                        v-model="studentResponses[index].response"
                        :module="module"
                        :worksheet-complete="worksheetComplete"
                    ></student-worksheet-module-choice>

                    <student-worksheet-module-choice
                        v-if="module.type === 'choice_one'"
                        v-model="studentResponses[index].response"
                        :module="module"
                        :worksheet-complete="worksheetComplete"
                    ></student-worksheet-module-choice>

                    <student-worksheet-module-choice
                        v-if="module.type === 'choice_many'"
                        v-model="studentResponses[index].response"
                        :module="module"
                        :worksheet-complete="worksheetComplete"
                    ></student-worksheet-module-choice>

                    <student-worksheet-module-range
                        v-if="module.type === 'range'"
                        v-model="studentResponses[index].response"
                        :module="module"
                        :worksheet-complete="worksheetComplete"
                    ></student-worksheet-module-range>

                    <student-worksheet-module-categorize
                        v-if="module.type === 'categorize'"
                        v-model="studentResponses[index].response"
                        :module="module"
                        :worksheet-complete="worksheetComplete"
                    ></student-worksheet-module-categorize>

                    <student-worksheet-module-order
                        v-if="module.type === 'order'"
                        v-model="studentResponses[index].response"
                        :module="module"
                        :worksheet-complete="worksheetComplete"
                    ></student-worksheet-module-order>

                    <student-worksheet-module-label
                        v-if="module.type === 'label'"
                        v-model="studentResponses[index].response"
                        :module="module"
                        :worksheet-complete="worksheetComplete"
                    ></student-worksheet-module-label>

                    <student-worksheet-module-flashcard-stack
                        v-if="module.type === 'flashcard_stack'"
                        v-model="studentResponses[index].response"
                        :module="module"
                        :worksheet-complete="worksheetComplete"
                    ></student-worksheet-module-flashcard-stack>
                </div>

                <div class="my-8 flex gap-4 text-center">
                    <Link
                        class="rounded border border-gray-400 px-3 py-2 text-gray-700 hover:cursor-pointer hover:bg-gray-300/20"
                        :href="
                            route('student.worksheet.reset-worksheet', {
                                worksheet: worksheet.id,
                            })
                        "
                        >Reset all answers
                    </Link>
                    <Link
                        v-if="worksheetComplete === false"
                        class="rounded bg-primary-525 px-3 py-3 text-[16px] text-white hover:cursor-pointer hover:bg-primary-600"
                        :href="route('student.worksheets.index')"
                        >Save progress
                    </Link>
                    <Link
                        v-else
                        class="rounded bg-primary-525 px-3 py-3 text-[16px] text-white hover:cursor-pointer hover:bg-primary-600"
                        :href="route('student.worksheets.index')"
                        >Save &amp; complete
                    </Link>
                </div>
            </div>
        </template>
    </student-backend-focus-layout>
</template>

<script>
import StudentBackendFocusLayout from "@/_Layouts/NewStudentBackendFocusLayout.vue";
import StudentWorksheetModuleRange from "@/Components/StudentWorksheetModuleRange.vue";
import StudentWorksheetModuleChoice from "@/Components/StudentWorksheetModuleChoice.vue";
import StudentWorksheetModuleOrder from "@/Components/StudentWorksheetModuleOrder.vue";
import StudentWorksheetModuleLabel from "@/Components/StudentWorksheetModuleLabel.vue";
import StudentWorksheetModuleCategorize from "@/Components/StudentWorksheetModuleCategorize.vue";
import StudentWorksheetModuleFlashcardStack from "@/Components/StudentWorksheetModuleFlashcardStack.vue";
import StudentWorksheetModuleText from "@/Components/StudentWorksheetModuleText.vue";

export default {
    name: "StudentWorksheetShow",
    components: {
        StudentWorksheetModuleText,
        StudentWorksheetModuleFlashcardStack,
        StudentWorksheetModuleCategorize,
        StudentWorksheetModuleLabel,
        StudentWorksheetModuleOrder,
        StudentWorksheetModuleChoice,
        StudentWorksheetModuleRange,
        StudentBackendFocusLayout,
    },
    props: {
        worksheet: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            worksheetsReady: false,
            studentResponses: [],
            showAnswerRationales: false,
            worksheetComplete: false,
            worksheetStartTime: null,
        };
    },
    methods: {
        exitWorksheet() {
            window.history.back();
        },
        saveProgress() {
            if (this.demoMode) {
                return;
            }

            let vm = this;

            let worksheetEndTime = new Date();
            let timeOnWorksheet = Math.round(
                (worksheetEndTime.getTime() - vm.worksheetStartTime.getTime()) /
                    1000
            );

            axios
                .post(
                    route("student.worksheet.save-worksheet", {
                        worksheet: this.worksheet.id,
                    }),
                    {
                        response: vm.studentResponses,
                        completed: vm.worksheetComplete,
                        time_spent: timeOnWorksheet,
                    }
                )
                .then(function (response) {
                    vm.worksheetStartTime = new Date();
                });
        },
    },
    computed: {},
    created() {
        let vm = this;

        let responseTree = [];

        this.worksheet.worksheet_modules.forEach(function (module, index) {
            module.showModuleRationale = false;

            responseTree[index] = {
                uuid: module.uuid,
                response: module.studentResponse
                    ? module.studentResponse
                    : null,
            };
        });

        this.studentResponses = responseTree;
        this.worksheetStartTime = new Date();
        this.worksheetsReady = true;
    },

    watch: {
        studentResponses: {
            handler: _.debounce(function (newValue, oldValue) {
                let vm = this;
                let worksheetComplete = true;

                newValue.forEach(function (module) {
                    if (!module.response || !module.response.module_complete) {
                        worksheetComplete = false;
                    }
                });

                if (worksheetComplete) {
                    vm.showAnswerRationales = true;
                    vm.worksheetComplete = true;
                } else {
                    vm.worksheetComplete = false;
                }

                vm.saveProgress();
                vm.$forceUpdate();
            }, 500),
            deep: true,
        },
    },
};
</script>

<style scoped></style>
